module.exports = __webpack_public_path__ + "static/MC_steps_reemplazo_FISICA_1_B-4bf2b4e828c0e7b5b235b8db43df75e4.gif";